import { useState, useEffect } from "react";
import { Sidebar } from "./sidebar";
import { Header } from "./header";
import { useIsMobileOrTablet } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";

interface MainLayoutProps {
  children: React.ReactNode;
}

export default function MainLayout({ children }: MainLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isMobileOrTablet = useIsMobileOrTablet();
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);

  // Auto-close sidebar when switching to desktop
  useEffect(() => {
    if (!isMobileOrTablet) {
      setSidebarOpen(false);
    }
  }, [isMobileOrTablet]);

  // Close sidebar when route changes on mobile/tablet
  useEffect(() => {
    if (isMobileOrTablet) {
      setSidebarOpen(false);
    }
  }, [isMobileOrTablet]);

  // Touch gesture handling for opening sidebar
  const minSwipeDistance = 50;

  const onTouchStart = (e: React.TouchEvent) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchEnd - touchStart;
    const isRightSwipe = distance > minSwipeDistance;

    if (isRightSwipe && isMobileOrTablet && !sidebarOpen) {
      setSidebarOpen(true);
    }
  };

  return (
    <div className="flex h-screen w-full overflow-hidden">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      <div 
        className={cn(
          "flex-1 flex flex-col overflow-hidden transition-all duration-300 w-full",
          // Desktop: add left margin for sidebar
          // !isMobileOrTablet && "lg:ml-64"

        )}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <Header onMenuClick={() => setSidebarOpen(true)} />
        
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-background w-full  p-8">
          <div className="fade-in w-full min-h-full">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
